//----------------------------------------
//------ JAVASCRIPT HOOK FUNCTIONS -------
//----------------------------------------
c7 = {
	hooks: { action: {}, filter: {} },
	addAction: function (action, callable, priority, tag) {
		c7.addHook("action", action, callable, priority, tag);
	},
	addFilter: function (action, callable, priority, tag) {
		c7.addHook("filter", action, callable, priority, tag);
	},
	doAction: function (action) {
		c7.doHook("action", action, arguments);
	},
	applyFilters: function (action) {
		return c7.doHook("filter", action, arguments);
	},
	removeAction: function (action, tag) {
		c7.removeHook("action", action, tag);
	},
	removeFilter: function (action, priority, tag) {
		c7.removeHook("filter", action, priority, tag);
	},
	addHook: function (hookType, action, callable, priority, tag) {
		if (undefined == c7.hooks[hookType][action]) {
			c7.hooks[hookType][action] = [];
		}
		var hooks = c7.hooks[hookType][action];
		if (undefined == tag) {
			tag = action + "_" + hooks.length;
		}
		if (priority == undefined) {
			priority = 10;
		}

		c7.hooks[hookType][action].push({
			tag: tag,
			callable: callable,
			priority: priority,
		});
	},
	doHook: function (hookType, action, args) {
		// splice args from object into array and remove first index which is the hook name
		args = Array.prototype.slice.call(args, 1);

		if (undefined != c7.hooks[hookType][action]) {
			var hooks = c7.hooks[hookType][action],
				hook;
			//sort by priority
			hooks.sort(function (a, b) {
				return a["priority"] - b["priority"];
			});
			for (var i = 0; i < hooks.length; i++) {
				hook = hooks[i].callable;
				if (typeof hook != "function") hook = window[hook];
				if ("action" == hookType) {
					hook.apply(null, args);
				} else {
					args[0] = hook.apply(null, args);
				}
			}
		}
		if ("filter" == hookType) {
			return args[0];
		}
	},
	removeHook: function (hookType, action, priority, tag) {
		if (undefined != c7.hooks[hookType][action]) {
			var hooks = c7.hooks[hookType][action];
			for (var i = hooks.length - 1; i >= 0; i--) {
				if (
					(undefined == tag || tag == hooks[i].tag) &&
					(undefined == priority || priority == hooks[i].priority)
				) {
					hooks.splice(i, 1);
				}
			}
		}
	},
};

/**
 * Detect if products are all rendered per collection.
 */
const detectCollectionRender = () => {
	const targetNodes = document.querySelectorAll(".c7-product-collection, .c7-personalization");

	if (!targetNodes.length) {
		return;
	}

	targetNodes.forEach((target) => {
		new MutationObserver((mutations, observer) => {
			if (document.querySelector(".c7-product-collection__products")) {
				observer.disconnect();
				c7.doAction("c7_collection_products_rendered", target);
				checkFooter();
			}
		}).observe(target, { childList: true, subtree: true });
	});
};

/**
 * Detect if products are all rendered in the collection page.
 */
 const detectCollectionPageRender = () => {
	const target = document.getElementById("c7-content");

	if (target) {
		new MutationObserver((_, observer) => {
			if (document.querySelector(".c7-product-collection__products")) {
				observer.disconnect();
				c7.doAction("c7_collection_products_rendered", target);
			}
			checkFooter();
		}).observe(target, { childList: true, subtree: true });
	}
};

/**
 * Detect if product detail content is rendered.
 */
const detectProductDetailVideoRender = () => {
	const target = document.getElementById("c7-content");

	if (target) {
		new MutationObserver((_, observer) => {
			observer.disconnect();
			c7.doAction("c7_product_detail_rendered", target);
			checkFooter();
		}).observe(target, { childList: true, subtree: true });
	}
};

const checkFooter = () => {
	const windowHeight = jQuery(window).height();
	const contentHeight = jQuery("body").height();
	const footerHeight = jQuery("footer").height();

	if (jQuery("footer").hasClass("sticky")) {
		if (windowHeight < (contentHeight + footerHeight))
			jQuery("footer").removeClass("sticky");
	} else {
		if (windowHeight > contentHeight)
			jQuery("footer").addClass("sticky");
	}
}

const detectProductPageRender = () => {
	const target = document.getElementById("c7-content");

	if (target) {
		new MutationObserver((_, observer) => {
			if (document.querySelector(".c7-product__image")) {
				observer.disconnect();
				c7.doAction("c7_products_detail_rendered", target);
			}
		}).observe(target, { childList: true, subtree: true });
	}
};

const detectProductGiftCardRender = () => {
	const target = document.getElementById("c7-content");

	if (target) {
		new MutationObserver((_, observer) => {
			if ( document.querySelector(".c7-product__add-to-cart__form" ) && document.querySelector(".show-popup-gift-card" ) ) {
				observer.disconnect();
				c7.doAction("c7_products_gift_card_rendered", target);
			}
		}).observe(target, { childList: true, subtree: true });
	}
};

const detectC7PageRender = () => {
	const target = document.getElementById("c7-content");

	if (target) {
		new MutationObserver((_, observer) => {
			if ( 
				document.querySelector(".c7-club-list" ) ||
				document.querySelector(".c7-cart__content" )
				) {
				observer.disconnect();
				c7.doAction("c7_page_rendered", target);
			}
		}).observe(target, { childList: true, subtree: true });
	}
};

const detectSideCartRender = () => {
	const target = document.querySelector('body');
	if (target) {
		new MutationObserver((_, observer) => {
			if( document.querySelector("#c7-side-cart" ) ) {
				observer.disconnect();
				c7.doAction("c7_side_cart_rendered", target);
			}
		}).observe(target, { childList: true, subtree: true });
	}
};

(function () {
	detectCollectionRender();
	detectProductDetailVideoRender();
	detectCollectionPageRender();
	detectProductPageRender();
	detectProductGiftCardRender();
	detectC7PageRender();
	detectSideCartRender();
})();
